import { CashFlowRequestEntity } from "features/cashFlow/domain/entities/CashFlowRequestEntity";

export class CashFlowRequestModel implements CashFlowRequestEntity {
  code?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  name?: string;
  type?: number;
  created?: Record<string, unknown>[];
  fromDate?: string;
  toDate?: string;
  store?: Array<string>;
  userRef?: Array<string>;
  partner?: string;
  isOnlyStore?: string;
  order?: string;
  phoneNumber?: string;
  storeCodes?: Array<string>;
  providerCode?: string;
  partnerCodes?: Array<string>;
  serviceCode?: string;
  transRef?: string;
  supplierRefCode?: string;

  constructor(data?: Partial<CashFlowRequestModel>) {
    this.code = data?.code;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.name = data?.name;
    this.type = data?.type;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.created = data?.created;
    this.store = data?.store;
    this.userRef = data?.userRef;
    this.partner = data?.partner;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
    this.phoneNumber = data?.phoneNumber;
    this.storeCodes = data?.storeCodes;
    this.providerCode = data?.providerCode;
    this.partnerCodes = data?.partnerCodes;
    this.serviceCode = data?.serviceCode;
    this.transRef = data?.transRef;
    this.supplierRefCode = data?.supplierRefCode;
  }
}
